import React from 'react'
import { Grid, Button, Paper, Table, TableHead, TableCell, TableBody } from '@material-ui/core'
import { connect } from 'react-redux'
import {
  GET_CATEGORIES,
  GET_ACTIVITY_TYPES,
  UPDATE_ACTIVITY_TYPE,
  ADD_ACTIVITY_TYPE,
  DELETE_ACTIVITY_TYPE,
} from './GraphQL'
import { useQuery, useLazyQuery, useMutation } from '@apollo/react-hooks'
import { startLoading, stopLoading } from '../../../actions/loading'
import { hasAccess } from '../../../utils/api'
import { formatErrors } from '../../../utils/common'

import ActivityTypeListItem from './ActivityTypeListItem'
import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'

import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import AddActivityTypeModal from '../../../components/Modal/AddActivityTypeModal'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ModalDialog from '../../../components/common/ModalDialog'

const ActivityTypeListItemEditable = EditableHOCWrapper(ActivityTypeListItem)

let columns = ['Name', 'Description', 'Categories', 'Status', '']

const ActivityTypes = (props) => {
  const permitted = hasAccess()
  const addActivityTypeModal = React.useRef(null)
  const deleteModal = React.useRef(null)
  const [activityTypeList, setActivityTypeList] = React.useState([])
  const [isUpdateCompleted, setIsUpdateCompleted] = React.useState(false)
  const [selectedItemToDelete, setSelectedItemToDelete] = React.useState({})
  const [categoryList, setCategoryList] = React.useState([])

  // eslint-disable-next-line no-unused-vars
  const resCategories = useQuery(GET_CATEGORIES, {
    onCompleted: (data) => {
      setCategoryList(data.categories)
      props.dispatch(stopLoading())
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [activityTypes, resActivityTypes] = useLazyQuery(GET_ACTIVITY_TYPES, {
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      setActivityTypeList(data.activityTypes)
      props.dispatch(stopLoading())
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [addActivityType, resAddActivityType] = useMutation(ADD_ACTIVITY_TYPE, {
    //refetchQueries: ["getComponentTypes"],
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      //Appcues.track("Component type Info saved");
      addActivityTypeModal.current.handleClose()
      onSuccess('New activity type saved')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [updateActivityType, resUpdateActivityType] = useMutation(UPDATE_ACTIVITY_TYPE, {
    //refetchQueries: props.refetchQueries,
    onCompleted: (data) => {
      setIsUpdateCompleted(true)
      props.dispatch(stopLoading())
      //Appcues.track("Component type Info saved");
      onSuccess('Activity type info saved')
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [deleteActivityType, resDeleteActivityType] = useMutation(DELETE_ACTIVITY_TYPE, {
    //refetchQueries: ["getComponentTypes"],
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      deleteModal.current.handleClose()
      //Appcues.track("Component type Info saved");
      onSuccess('Activity type deleted')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  React.useEffect(() => {
    fetchApi()
  }, [])

  const fetchApi = () => {
    props.dispatch(startLoading())
    setActivityTypeList([])
    activityTypes({
      variables: {},
    })
  }

  const onError = (message) => props.dispatch(openErrorMessage(message))
  const onSuccess = (message) => props.dispatch(openSuccessMessage(message))

  const validateActivityType = (data) => {
    if (!data.name) {
      onError('Please provide a valid activity type name')
      return false
    }
    if (data.categories.length === 0) {
      onError('Please provide a activity type categories')
      return false
    }
    return true
  }

  const onSave = (data, afterOnSave) => {
    if (validateActivityType(data)) {
      setIsUpdateCompleted(false)
      const input = {
        id: data.id,
        name: data.name,
        description: data.description,
        active: data.active,
        categories: data.categories,
      }
      props.dispatch(startLoading())
      updateActivityType({ variables: { input } })
    }
  }

  const addActivityTypeApiCall = (data) => {
    props.dispatch(startLoading())
    addActivityType({ variables: { input: data } })
  }

  const openDeleteModal = (item) => (e) => {
    setSelectedItemToDelete(item)
    deleteModal.current.handleClickOpen()
  }

  const onDeleteItem = (e) => {
    props.dispatch(startLoading())
    deleteActivityType({ variables: { id: selectedItemToDelete.id } })
  }

  return (
    <div>
      <Grid container>
        <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
          {permitted ? (
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={() => addActivityTypeModal.current.handleClickOpen()}
            >
              Add Activity Type
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll">
              <Table>
                <TableHead>
                  {columns && columns.map((col) => <TableCell>{col}</TableCell>)}
                </TableHead>
                <TableBody>
                  {activityTypeList &&
                    activityTypeList.length > 0 &&
                    activityTypeList.map((data, index) => (
                      <ActivityTypeListItemEditable
                        key={index}
                        dataToEdit={data}
                        onSave={onSave}
                        isUpdateCompleted={isUpdateCompleted}
                        onDelete={openDeleteModal(data)}
                        categoryList={categoryList}
                      />
                    ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <AddActivityTypeModal
        ref={addActivityTypeModal}
        addActivityType={addActivityTypeApiCall}
        onError={onError}
        categoryList={categoryList}
      />
      <ModalDialog ref={deleteModal} onConfirm={onDeleteItem} confirmText="delete">
        Are you sure you want to delete '{selectedItemToDelete.name}'
      </ModalDialog>
    </div>
  )
}

export default connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ContainerWithTitle(ActivityTypes, 'Activity Types'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/ActivityTypes.js